import Controller from '@ember/controller'
import { getResearchReportsViewModel } from 'teacher-ui-client/subscription-type/quick-links/contentful-view-models'
import type ResearchReportsRoute from 'teacher-ui-client/subscription-type/quick-links/research-reports/route'

interface ResearchReportItem {
  title: string
  description: string
  coverUrl: string
  fileUrl: string
}

export default class ResearchReportsController extends Controller {
  declare model: ModelFor<ResearchReportsRoute>

  get researchReports(): ResearchReportItem[] {
    // @ts-expect-error - we're filtering out entries without a cover or file url so these will always be defined
    return getResearchReportsViewModel(this.model.researchReports).filter(
      (entry) => entry.fileUrl && entry.coverUrl && entry.description,
    )
  }
}
